import config from "@Config/index";
import {
  ROOM_TYPE_FILTER,
  ROOM_TYPE_SPECIFIC,
  SHARING_OPTIONS_BATHROOM,
  SHARING_OPTIONS_KITCHEN,
} from "@Pages/Search/components/FilterSection/data/filtersList";
import { metaTypesHas } from "@Pages/Search/components/SearchList/helper";
import axios from "axios";

const fetchInventoryRooms = async ({ id, params = {}, selectedLang }: any) => {
  const language = selectedLang;

  let updatedParams = {
    type: "empty",
    limit: 200,
    use_open_search: true,
    lang: language || "en",
    include_offers: "false", // add offers to tenancy level
    only: "id,name,pricing,tags,meta,images,virtual_views,features,description,available,parent_id,message,videos",
    // methods: "active_children",
    active_children_with_filters: true,
    filter_available_rooms_tenancies: false,
    ...params,
    use_v2_structure: true,
  };

  if (config.IS_CHINA_APP) {
    updatedParams.temp_param = "cache_invalidation";
  }

  if (updatedParams?.meta_types) {
    updatedParams = {
      ...updatedParams,
      room_types: [...ROOM_TYPE_FILTER.list, ...ROOM_TYPE_SPECIFIC.list]
        .map((it) => it.value)
        .filter((it) => metaTypesHas(updatedParams?.meta_types, it))
        .join(","),
      bathroom_types: SHARING_OPTIONS_BATHROOM.list
        .map((it) => it.value)
        .filter((it) => metaTypesHas(updatedParams?.meta_types, it))
        .join(","),
      kitchen_types: SHARING_OPTIONS_KITCHEN.list
        .map((it) => it.value)
        .filter((it) => metaTypesHas(updatedParams?.meta_types, it))
        .join(","),
    };
    delete updatedParams?.meta_types;
    if (!updatedParams.bathroom_types) {
      delete updatedParams.bathroom_types;
    }
    if (!updatedParams.kitchen_types) {
      delete updatedParams.kitchen_types;
    }
    if (!updatedParams.room_types) {
      delete updatedParams.room_types;
    }
  }

  // if (params?.tags?.includes("dual_occupancy")) {
  //   updatedParams.meta_dual_occupancy = true;
  // }

  // if (params?.tags?.includes("dual_occupancy")) {
  //   updatedParams.meta_dual_occupancy = true;
  // }

  try {
    return await axios.get(`${config.API_URL}/api/v0/inventories/${id}/room_types`, {
      params: { ...updatedParams, use_java_api: true },
      headers: { "X-Use-Java-Api": "true" },
      ...config.apiParams,
    });
  } catch (error) {
    if (typeof window !== undefined && typeof window.Sentry !== "undefined") {
      window.Sentry.captureException(`Failed to fetch inventory rooms -> ${error}`, {
        extra: {
          language,
          inventoryId: id,
          params: updatedParams,
          configApiParams: config.apiParams,
        },
      });
    }
    return null;
  }
};

export default fetchInventoryRooms;
